<template>
    <div class="mid-scanner">
      <div class="corner top-left"></div>
      <div class="corner top-right"></div>
      <div class="corner bottom-left"></div>
      <div class="corner bottom-right"></div>
    </div>
</template>

<style scopped>
.mid-scanner {
  pointer-events: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 55vw;
  max-width: 300px;
  max-height: 300px;
  aspect-ratio: 1 / 1;
  z-index: 1001;
}

.corner {
  pointer-events: none;
  position: absolute;
  width: 30%;
  height: 30%;
  border: 5px solid white;
  box-sizing: border-box;
  z-index: 1001;
}

.top-left {
  pointer-events: none;
  top: 0;
  left: 0;
  border-right: none;
  border-bottom: none;
  border-top-left-radius: 50%;
}

.top-right {
  pointer-events: none;
  top: 0;
  right: 0;
  border-left: none;
  border-bottom: none;
  border-top-right-radius: 50%;
}

.bottom-left {
  pointer-events: none;
  bottom: 0;
  left: 0;
  border-right: none;
  border-top: none;
  border-bottom-left-radius: 50%;
}

.bottom-right {
  pointer-events: none;
  bottom: 0;
  right: 0;
  border-left: none;
  border-top: none;
  border-bottom-right-radius: 50%;
}
</style>